/* unplugin-vue-components disabled */import script from "./layout.vue?vue&type=script&setup=true&lang=js"
export * from "./layout.vue?vue&type=script&setup=true&lang=js"

import "./layout.vue?vue&type=style&index=0&id=831905f4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-831905f4"]])

export default __exports__